import ApiService from "../../service/api/ApiService";
import ApiUrls from "../../service/api/ApiUrls";
import CacheStorage from "../../service/storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";
import ShowToast from "../../widget/common/ui/Toast";
import {
  ChatMediaUploadedDetailModel,
  UploadEncryptedMedia,
} from "../../model/chats/ChatMediaUploadedDetailModel";

const ImagePickerPreviewProvider = new (class ImagePickerPreviewProvider {
  uploadMediaChatFile = async (params: {
    convId: string;
    mediaFile: File;
    mediaFileName: string;
    compId?: string;
    acctId?: string;
  }): Promise<UploadEncryptedMedia | null> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const companyId: string =
      CacheStorage.getValue(StorageKeys.company_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl2}conversation/upload_conversation_media`;

    const formData = new FormData();
    formData.append("account_id", params.acctId ?? accountId);
    formData.append("company_id", params.compId ?? companyId);
    formData.append("conv_id", params.convId ?? "");
    formData.append("flag", "1");
    formData.append("file", params.mediaFile ?? "");
    formData.append("fileName", params.mediaFileName ?? "");

    const response: any = await ApiService.postApi(url, formData, false, true);

    if (response != null) {
      if (response["success"] === "1") {
        const chatMediaUploadedDetailModel: ChatMediaUploadedDetailModel =
          response;
        const uploadEncryptedMedia: UploadEncryptedMedia =
          chatMediaUploadedDetailModel?.result?.upload_encrypted_media!;
        return uploadEncryptedMedia;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };

  uploadImage = async (params: {
    compId?: string;
    acctId?: string;
    flag: string;
    fileID: string;
    file: File;
  }): Promise<boolean> => {
    ApiUrls.init();

    const accountId: string =
      CacheStorage.getValue(StorageKeys.account_id) ?? "0";
    const companyId: string =
      CacheStorage.getValue(StorageKeys.company_id) ?? "0";
    const url: string = `${ApiUrls.baseUrl}upload/upload_media`;

    const formData = new FormData();
    formData.append("account_id", params.acctId ?? accountId);
    formData.append("company_id", params.compId ?? companyId);
    formData.append("flag", params.flag);
    formData.append("file_id", params.fileID);
    formData.append("file", params.file);

    const response: any = await ApiService.postApi(url, formData, false, true);
    if (response != null) {
      if (response["success"] === "1") {
        return true;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return false;
  };
})();

export default ImagePickerPreviewProvider;
